import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <span className="footer-separator">•</span>
        <Link to="/terms">Terms &amp; Conditions</Link>
        <span className="footer-separator">•</span>
        <Link to="/safety-disclaimer">Safety Disclaimer</Link>
        <span className="footer-separator">•</span>
        <Link to="/return-policy">Return Policy</Link>
      </div>
      <div className="footer-copy">
        © {new Date().getFullYear()} The Pink Collective, LLC
      </div>
    </footer>
  );
}

export default Footer;
